<div id="copy-legacy-files">
  <h3 class="aligned-center">Copy Legacy Files</h3>
  <br />

  <div class="main-content">
    <div class="form-row">
      <div class="form-label-col"></div>
      <div class="form-label-col aligned-end mt-2">Tax Year:</div>
      <div class="form-value-col dropdown-col">
        <select
          class="form-control tax-year-select"
          [ngModel]="selectedTaxYear"
          (ngModelChange)="selectedTaxYear = $event"
          name="taxYear">
          <option [ngValue]="null" disabled>Select Tax Year</option>
          @for (taxYear of taxYears; track $index) {
<option [ngValue]="taxYear">
            {{ taxYear.text }}
          </option>
}
        </select>
      </div>
      <div class="form-value-col justify-center">
        <button
          class="submit-button"
          type="button"
          [disabled]="!selectedTaxYear || copyingLegacyFiles"
          (click)="moveLegacyFilestoS3()">
          @if (copyingLegacyFiles) {
<span><i class="fa fa-spinner fa-spin"></i></span>
}
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
